import { create } from "zustand";

const useCartStore = create((set) => ({
  result: [],
  lastAddedItem: {},

  addToCart: (product) =>
    set((state) => {
      if (state.result.some((ci) => ci.fortnoxNumber === product.fortnoxNumber)) {
        return state;
      }
      return { result: [...state.result, product] };
    }),

  deleteFromCart: (fortnoxNumber) =>
    set((state) => {
      const res = state.result.filter((item) => item.fortnoxNumber !== fortnoxNumber);
      let lastItem = state.lastAddedItem;

      if (lastItem.isPlusPackage) {
        if (lastItem.plusPackage.fortnoxNumber === fortnoxNumber) {
          lastItem = lastItem.studentLicense;
        } else {
          lastItem = lastItem.plusPackage;
        }
      } else {
        if (lastItem.fortnoxNumber === fortnoxNumber) {
          const firstStudentLicense = res.find((r) => r.type === "StudentLicense");

          if (firstStudentLicense) {
            const matchingPlusLicense = res.find(
              (r) =>
                r.programLicenseId === firstStudentLicense.programLicenseId &&
                r.fortnoxNumber !== firstStudentLicense.fortnoxNumber
            );

            if (matchingPlusLicense) {
              lastItem = {
                isPlusPackage: true,
                plusPackage: matchingPlusLicense,
                studentLicense: firstStudentLicense,
              };
            } else {
              lastItem = firstStudentLicense;
            }
          } else if (res.length > 0) {
            lastItem = res[0];
          } else {
            lastItem = {};
          }
        }
      }

      return { result: res, lastAddedItem: lastItem };
    }),

  addStudentToCartItem: (student, fortnoxNumber) =>
    set((state) => ({
      result: state.result.map((prod) =>
        prod.fortnoxNumber === fortnoxNumber
          ? { ...prod, addedStudents: [...prod.addedStudents, student] }
          : prod
      ),
    })),

  removeStudentFromCartItem: (student, fortnoxNumber) =>
    set((state) => ({
      result: state.result.map((prod) =>
        prod.fortnoxNumber === fortnoxNumber
          ? {
              ...prod,
              addedStudents: prod.addedStudents.filter((stud) => stud.id !== student.id),
            }
          : prod
      ),
    })),

  addManyStudentsToCartAndLastAdded: (students, fortnoxNumber) =>
    set((state) => {
      const addUnique = (existing, toAdd) => {
        const result = [...existing];
        toAdd.forEach((stud) => {
          if (!result.some((s) => s.id === stud.id)) {
            result.push(stud);
          }
        });
        return result;
      };

      const newResult = state.result.map((prod) =>
        prod.fortnoxNumber === fortnoxNumber
          ? { ...prod, addedStudents: addUnique(prod.addedStudents, students) }
          : prod
      );

      let newLastAdded;
      if (!state.lastAddedItem.isPlusPackage) {
        newLastAdded = {
          ...state.lastAddedItem,
          addedStudents: addUnique(state.lastAddedItem.addedStudents, students),
        };
      } else {
        newLastAdded = {
          ...state.lastAddedItem,
          plusPackage: {
            ...state.lastAddedItem.plusPackage,
            addedStudents: addUnique(
              state.lastAddedItem.plusPackage.addedStudents,
              students
            ),
          },
        };
      }

      return { result: newResult, lastAddedItem: newLastAdded };
    }),

  removeManyStudentsFromCartAndLastAdded: (studentIds, fortnoxNumber) =>
    set((state) => {
      const newResult = state.result.map((prod) =>
        prod.fortnoxNumber === fortnoxNumber
          ? {
              ...prod,
              addedStudents: prod.addedStudents.filter(
                (stud) => !studentIds.includes(stud.id)
              ),
            }
          : prod
      );

      let newLastAdded;
      if (state.lastAddedItem.isPlusPackage) {
        if (fortnoxNumber === state.lastAddedItem.plusPackage.fortnoxNumber) {
          newLastAdded = {
            ...state.lastAddedItem,
            plusPackage: {
              ...state.lastAddedItem.plusPackage,
              addedStudents: state.lastAddedItem.plusPackage.addedStudents.filter(
                (stud) => !studentIds.includes(stud.id)
              ),
            },
          };
        } else {
          newLastAdded = state.lastAddedItem;
        }
      } else {
        newLastAdded = {
          ...state.lastAddedItem,
          addedStudents: state.lastAddedItem.addedStudents.filter(
            (stud) => !studentIds.includes(stud.id)
          ),
        };
      }

      return { result: newResult, lastAddedItem: newLastAdded };
    }),

  clearCart: () => set({ result: [], lastAddedItem: {} }),

  setLastAddedItem: (lastAddedItem) => set({ lastAddedItem }),
}));

export default useCartStore;
